import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Link,
} from 'react-router-dom';
import Root from './routes/Root.js';
import Info from './routes/Info.js';
import Faq from './routes/Faq.js';
import Archive from './routes/Archive.js';
import About from './routes/About.js';
import Contact from './routes/Contact.js';
import Guide from './routes/Guide.js';
import './styles/index.css';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
  }, 
  {
    path: 'info',
    element: <Info />,  
  },
  {
    path: 'faq',
    element: <Faq />
  },
  {
    path: 'archive',
    element: <Archive />
  },
  {
    path: 'about',
    element: <About />,  
  },
  {
    path: 'contact',
    element: <Contact />,
  },
  {
    path: 'shootguide',
    element: <Guide />
  }
]);

createRoot(document.getElementById('root')).render(
  <RouterProvider router={router} />
);
